import { useMemo } from 'react'

/**
 * Sternenhimmel im Hintergrund.
 *
 * Einmal beim Einhaengen erzeugt und danach nie wieder neu berechnet: Jedes
 * Neuzeichnen waehrend einer Runde wuerde die Sterne springen lassen, und das
 * lenkt genau in dem Moment ab, in dem das Kind rechnet.
 */
export function Sterne({ anzahl = 40 }: { anzahl?: number }) {
  const sterne = useMemo(
    () =>
      Array.from({ length: anzahl }, () => ({
        links: Math.random() * 100,
        oben: Math.random() * 100,
        groesse: 0.3 + Math.random() * 0.7,
        verzoegerung: Math.random() * 4,
      })),
    [anzahl],
  )

  return (
    <div className="sterne" aria-hidden="true">
      {sterne.map((s, i) => (
        <span
          key={i}
          className="stern"
          style={{
            left: `${s.links}%`,
            top: `${s.oben}%`,
            width: `${s.groesse}vmin`,
            height: `${s.groesse}vmin`,
            animationDelay: `${s.verzoegerung}s`,
          }}
        />
      ))}
    </div>
  )
}

const KONFETTI_FARBEN = [
  'var(--gold)',
  'var(--gruen)',
  'var(--rot)',
  'var(--blau)',
  'var(--lila)',
]

export function Konfetti({ anzahl = 60 }: { anzahl?: number }) {
  const schnipsel = useMemo(
    () =>
      Array.from({ length: anzahl }, () => ({
        links: Math.random() * 100,
        dauer: 2.4 + Math.random() * 2.2,
        verzoegerung: Math.random() * 1.6,
        farbe: KONFETTI_FARBEN[Math.floor(Math.random() * KONFETTI_FARBEN.length)]!,
        neigung: Math.random() * 360,
      })),
    [anzahl],
  )

  return (
    <div className="konfetti" aria-hidden="true">
      {schnipsel.map((s, i) => (
        <span
          key={i}
          className="schnipsel"
          style={{
            left: `${s.links}%`,
            background: s.farbe,
            animationDuration: `${s.dauer}s`,
            animationDelay: `${s.verzoegerung}s`,
            transform: `rotate(${s.neigung}deg)`,
          }}
        />
      ))}
    </div>
  )
}
